/**
 * The subset of the Kilo design system the onboarding checklist needs, taken from the
 * prototype's `colors_and_type.css`. They live here rather than in the Mantine theme
 * because nothing outside this feature uses them yet.
 */

/** `--green-07`, the design system's `--text-success` / `--border-success`. */
export const COMPLETION_GREEN = '#3CB553';

/** `--text-quaternary`, the brand-tinted text used for the per-card time estimate. */
export const TIME_ESTIMATE_COLOR = '#082B6D';

/** `--radius-md`. The checkbox reads as a circle at the theme's default radius. */
export const CHECKBOX_RADIUS = 4;
